import { breakpoints } from './variables';
type CallbackFunction = (data: string) => void;

interface EventBus {
  events: { [key: string]: CallbackFunction[] };
  subscribe(event: string, callback: CallbackFunction): void;
  publish(event: string, data: string): void;
}

export const eventBus: EventBus = {
  events: {},
  subscribe(event: string, callback: CallbackFunction) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  },
  publish(event: string, data: string) {
    if (this.events[event]) {
      this.events[event].forEach(callback => {
        callback(data);
      });
    }
  }
};

const handleMedia = (e: MediaQueryListEvent, breakpoint: string) => {
  if (e.matches) {
    eventBus.publish('breakpointChange', breakpoint);
  }
};

export const addWindowBreakpoints = () => {
  const mobileMQ = window.matchMedia(`(max-width:${breakpoints.mobile}px)`);
  mobileMQ.addEventListener('change', e => handleMedia(e, 'mobile'));

  const tabletMQ = window.matchMedia(
    `(max-width:${breakpoints.tablet}px) and (min-width:${breakpoints.mobile}px)`
  );

  tabletMQ.addEventListener('change', e => handleMedia(e, 'tablet'));
  const tabletLandscapeMQ = window.matchMedia(
    `(max-width:${breakpoints.tabletLandscape}px) and (min-width:${breakpoints.tablet}px)`
  );
  tabletLandscapeMQ.addEventListener('change', e => handleMedia(e, 'tabletLandscape'));
  const desktopMQ = window.matchMedia(
    `(max-width:${breakpoints.desktop}px) and (min-width:${breakpoints.tabletLandscape}px)`
  );
  desktopMQ.addEventListener('change', e => handleMedia(e, 'desktop'));
  const wideMQ = window.matchMedia(`(min-width:${breakpoints.wide}px)`);
  wideMQ.addEventListener('change', e => handleMedia(e, 'wide'));

  if (mobileMQ.matches) eventBus.publish('breakpointChange', 'mobile');
  if (tabletMQ.matches) eventBus.publish('breakpointChange', 'tablet');
  if (tabletLandscapeMQ.matches) eventBus.publish('breakpointChange', 'tabletLandscape');
  if (desktopMQ.matches) eventBus.publish('breakpointChange', 'desktop');
  if (wideMQ.matches) eventBus.publish('breakpointChange', 'wide');
};
